<template>
  <div class="main">
    <v-row>
      <v-col @click="link('new')">
        <div>
          <div>
            <img src="@/assets/images/bayer/main/img_new.png" alt="">
          </div>
        </div>
        <p>신규혜택</p>
      </v-col>
      <v-col @click="link('kakao')">
        <div>
          <div>
            <img src="@/assets/images/bayer/main/img_kakao.png" alt="">
          </div>
        </div>
        <p>카카오 채널</p>
      </v-col>
      <v-col @click="link('youtube')">
        <div>
          <div>
            <img src="@/assets/images/bayer/main/img_youtube.png" alt="">
          </div>
        </div>
        <p>유튜브</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col @click="link('alion')">
        <div>
          <div  class="img-wrap">
            <img src="@/assets/images/bayer/main/img_alion.jpg" alt="">
          </div>
        </div>
        <p>알리온플러스</p>
      </v-col>
      <v-col @click="link('chat')">
        <div>
          <div>
            <img src="@/assets/images/bayer/main/img_chat.png" alt="">
          </div>
        </div>
        <p>제품상담</p>
      </v-col>
      <v-col @click="link('info')">
        <div>
          <div>
            <img src="@/assets/images/bayer/main/img_info.png" alt="">
          </div>
        </div>
        <p>제품정보</p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {

  methods: {
    link(to) {
      if (to === 'new') {
        this.$emit('clickNew');
        return;
      }
      let linkUrl
      switch (to) {
        case 'youtube':
          linkUrl = 'https://www.youtube.com/@BayerCropScienceKorea'
          break;
        case 'kakao':
          linkUrl = 'https://pf.kakao.com/_xjWExoxl/friend/'
          break;
        case 'alion':
          linkUrl = 'https://www.alionplus.co.kr/'
          break;
        case 'chat':
          linkUrl = 'https://www.cropscience.bayer.co.kr/contact'
          break;
        case 'info':
          linkUrl = 'https://www.cropscience.bayer.co.kr/'
          break;

      }
      window.open(linkUrl, '_blank');
    }
  }
};
</script>
<style lang="scss">
@media (min-width: 768px) {
  div.main {
    width: 100%;
  }
}

.main {
  width: 90vw;
  margin: 0 auto;

  .row {
    .col {
      text-align: center;

      .img-wrap {
        display: inline-block;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
      }

      img {
        width: 80px;
      }

      p {
        font-weight: 900;
      }
    }
  }
}</style>